module.exports = __webpack_public_path__ + "img/titlebg.4d63beaf.jpg";